import { BonusMarketTypeExclusion, MarketType, MarketTypeType, MarketTypeUsedFor } from '../../../../../@types/api';
import { formatSnakeCaseString } from '../../../../../utils';

export type BonusMarketTypeExclusionsResponse = {
  items: BonusMarketTypeExclusion[];
};

export type BonusMarketTypeExclusionSelector = {
  sportId?: string;
  usedFor?: MarketTypeUsedFor;
  type?: Exclude<MarketTypeType, 'match_and_outright'>;
};

export type BonusMarketTypeExclusionSelectorsResponse = {
  selectors: BonusMarketTypeExclusionSelector[];
};

export type MarketTypeExclusionsFilterFormData = {
  sportId: string | null;
  usedFor: string | null;
  type: MarketTypeType | '';
};

export const MARKET_TYPE_EXCLUSIONS_DEFAULT_VALUES: MarketTypeExclusionsFilterFormData = {
  sportId: '',
  usedFor: '',
  type: 'match',
};

export const formatMarketTypeContext = (marketType: MarketType) => {
  const usedFor = marketType.usedFor?.length
    ? marketType.usedFor.map((value) => formatSnakeCaseString(value)).join(', ')
    : '';

  return [marketType.sport?.name, usedFor].filter(Boolean).join(' - ');
};

export const getMarketTypesFromExclusions = (exclusions: BonusMarketTypeExclusion[]) =>
  exclusions.map((exclusion) => exclusion.marketType).filter((marketType): marketType is MarketType => !!marketType);

export const getMarketTypesToAdd = (
  marketTypesById: Map<string, MarketType>,
  checkedMarketTypeIds: string[],
  selectedMarketTypeIds: Set<string>
) =>
  checkedMarketTypeIds
    .map((marketTypeId) => marketTypesById.get(marketTypeId))
    .filter((marketType): marketType is MarketType => !!marketType && !selectedMarketTypeIds.has(marketType.id));

export const getBonusMarketTypeExclusionSelectorKey = (selector: BonusMarketTypeExclusionSelector) =>
  [selector.sportId ?? '', selector.usedFor ?? '', selector.type ?? ''].join('|');

export const deduplicateBonusMarketTypeExclusionSelectors = (selectors: BonusMarketTypeExclusionSelector[]) => {
  const selectorsByKey = new Map(
    selectors.map((selector) => [getBonusMarketTypeExclusionSelectorKey(selector), selector])
  );

  return Array.from(selectorsByKey.values());
};

export const formatBonusMarketTypeExclusionSelector = (
  selector: BonusMarketTypeExclusionSelector,
  sportsById: Map<string, string>
) => {
  const values = [
    selector.sportId ? sportsById.get(selector.sportId) || `Sport ${selector.sportId}` : undefined,
    selector.usedFor ? formatSnakeCaseString(selector.usedFor) : undefined,
    selector.type ? formatSnakeCaseString(selector.type) : undefined,
  ].filter(Boolean);

  return values.length ? values.join(' · ') : 'All markets';
};
